module.exports = __webpack_public_path__ + "img/6.f032f680.jpeg";